export default __webpack_public_path__ + "static/media/widowmaker-icon.d8797c7b.webp";